module.exports = __webpack_public_path__ + "static/media/bbc_news_live_uk-politics-36050790_plot.82270cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_live_uk-politics-36050790_plot.png
// module id = 352
// module chunks = 0